import React from "react";

const ManufacurerIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20"><path d="M-13175.647 217.086v-6.186a2.37 2.37 0 0 0-2.352-2.383 2.37 2.37 0 0 0-2.354 2.383v6.19h-5.178a.474.474 0 0 1-.471-.475v-13.815a.484.484 0 0 1 .2-.4l7.533-5.237a.465.465 0 0 1 .531 0l7.528 5.237a.477.477 0 0 1 .205.4v13.81a.471.471 0 0 1-.469.475zm-4.705 0z" transform="translate(13186.001 -197.086)" fill={props.fill}/></svg>
    )
}

export default ManufacurerIcon;
